{
  "login-page": {
    "buttons": {
      "next": "Další",
      "sign-up": "Vytvořit nový účet",
      "update-password": "Aktualizace hesla",
      "use-phone-to-login": "Přihlášení pomocí telefonního čísla",
      "use-email-to-login": "Přihlášení pomocí e-mailu"
    },
    "text": {
      "title": "Přihlášení",
      "subtitle": "Přihlášení do služby Beauty Booking",
      "email": "Váš e-mail",
      "or": "NEBO",
      "password": "Heslo",
      "password-hint": "Je třeba aktualizovat heslo",
      "username": "Uživatelské jméno",
      "username-hint": "Musíte zadat svůj e-mail nebo telefonní číslo"
    }
  }
}
